import React, { useState, useCallback } from "react";
import {
	SettingToggle,
	Banner,
	Card,
	Icon,
	TextContainer,
	Heading,
	Button,
} from "@shopify/polaris";
import callApi from "../../utils/apiCaller";
import { useSelector, useDispatch } from "react-redux";
import { actFetchDataSettings, actFetchShowLoadingPage } from "../../actions";
import { Col, Row } from "reactstrap";
import {
	DeleteMajor,
	DomainNewMajor,
	DuplicateMinor,
} from "@shopify/polaris-icons";
import logoOT from "../../assets/logo_ot.png";
import uuid from "uuid-random";
import CopyToClipboard from "react-copy-to-clipboard";
import SaveDataOrderNote from "./SaveDataOrderNote";
const General = () => {
	const dispatch = useDispatch();
	const [copied, setCopied] = useState(false);
	const dataSettings = useSelector((state) => state.dataSettings);
	const generateOtAPIKey = () => {
		let params = {
			action: "generateKey",
		};
		dispatch(actFetchShowLoadingPage(true));
		callApi("get", params, "order_tracking/services.php").then(
			async (res) => {
				dispatch(actFetchShowLoadingPage(false));
				if (res.status === 200) {
					let newDataSettings = { ...dataSettings };
					newDataSettings.order_tracking_api_key = res.data.key;
					dispatch(actFetchShowLoadingPage(false));
					dispatch(actFetchDataSettings(newDataSettings));
				}
			}
		);
	};
	const deleteAPIKey = () => {
		let params = {
			action: "deleteAPIKey",
		};
		dispatch(actFetchShowLoadingPage(true));
		callApi("get", params, "order_tracking/services.php").then(
			async (res) => {
				if (res.status === 200) {
					let newDataSettings = { ...dataSettings };
					newDataSettings.order_tracking_api_key = null;
					dispatch(actFetchShowLoadingPage(false));
					dispatch(actFetchDataSettings(newDataSettings));
				}
			}
		);
	};

	return (
		<div style={{ marginTop: "20px" }}>
			<Card sectioned title="Advanced settings">
				<Row
					// style={{ textAlign: 'end' }}
					className="mb-2"
				>
					<Col>
						<a
							href="https://docs.synctrack.io/feature-guides/sync-info-to-shopify-order-note-available-for-pro-and-above-plan"
							target="_blank"
						>
							View Shopify order note instruction
						</a>
					</Col>
				</Row>
				<SaveDataOrderNote />
			</Card>
		</div>
	);
};

export default General;
